<footer class="fm-footer fm-ft-pattern">
  <div class="container-xl">
    <div class="row g-4">

      <!-- Brand + Social -->
      <div class="col-xl-4">
        <div class="row">
          <div class="col-xxl-10">
            <div class="fm-footer-logo mt-3 mt-xl-0">
              <a href="/" routerLink="/"><img src="images/logo.svg" alt="Footer Logo" /></a>
            </div>
            <p>Preserving life stories for generations to come</p>
            <div class="fm-social-icons">
              <ul class="fm-icons">
                <li><a href="javascript:void(0);"><img src="images/icons/fm-fb.svg" alt="FB Icon" /></a></li>
                <li><a href="javascript:void(0);"><img src="images/icons/fm-twitter.svg" alt="Twitter Icon" /></a></li>
                <li><a href="javascript:void(0);"><img src="images/icons/fm-linkedin.svg" alt="linkedin Icon" /></a></li>
                <li><a href="javascript:void(0);"><img src="images/icons/fm-insta.svg" alt="Instagram Icon" /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Product + Company -->
      <div class="col-md-6 col-xl-4">
        <div class="row">
          <div class="col-6">
            <div class="fm-ft-nav mt-3 mt-xl-0">
              <h3 class="fm-ft-head fm-head-26">Product</h3>
              <ul>
                <li class="nav-item fm-nav-item"><a class="nav-link fm-nav-link" href="#fmFeatures">Features</a></li>
                <li class="nav-item fm-nav-item"><a class="nav-link fm-nav-link" href="#fmHowItWorks">How It Works</a></li>
                <li class="nav-item fm-nav-item"><a class="nav-link fm-nav-link" href="#">Pricing</a></li>
              </ul>
            </div>
          </div>
          <div class="col-6">
            <div class="fm-ft-nav mt-3 mt-xl-0">
              <h3 class="fm-ft-head fm-head-26">Company</h3>
              <ul>
                <li><a href="javascript:void(0);">About Us</a></li>
                <li><a href="javascript:void(0);">Contact</a></li>
                <li><a href="javascript:void(0);">Support</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact -->
      <div class="col-md-6 col-xl-4">
        <div class="fm-ft-nav mt-3 mt-xl-0">
          <h3 class="fm-ft-head fm-head-26">Contact</h3>
          <ul>
            <li>
              <a href="javascript:void(0);">
                <img src="images/icons/fm-address.svg" class="fm-svg" alt="" />
                <span>110 Woodcroft Dr, Rochester, New York 14616, USA</span>
              </a>
            </li>
            <li>
              <a href="mailto:forevermemories@gmail.com">
                <img src="images/icons/fm-mail.svg" class="fm-svg" alt="" />
                <span>forevermemories@gmail.com</span>
              </a>
            </li>
            <li>
              <a href="tel:112345678901">
                <img src="images/icons/fm-phone.svg" class="fm-svg" alt="" />
                <span>+1 (1234) 567 8901</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</footer>

<!-- Copyright -->
<div class="fm-copyright">
  <div class="container-xl">
    <div class="row">
      <div class="col-12">
        <p class="mb-0">&copy; 2026 Forever Memories. Your memories are private and secure.</p>
      </div>
    </div>
  </div>
</div>
